import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderExchangeListContainer from '../../containers/order/OrderExchangeListContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderExchangeList = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_EXCHANGE_LIST}>
      <OrderExchangeListContainer pageName={ORDER_PAGE_NAME.ORDER_EXCHANGE_LIST} />
    </PageTemplate>
  );
};

export default OrderExchangeList;
